/**
 * Formats a millisecond duration for the compact one-line history rows
 * (identity resolution calls, payment API calls): sub-second in `мс`,
 * one second and up in `с` with one decimal. `null` (duration unknown)
 * renders as an em dash.
 */
export function formatDurationMs(ms) {
    if (ms === null)
        return '—';
    return ms >= 1000 ? `${(ms / 1000).toFixed(1)} с` : `${ms} мс`;
}
/**
 * Длительность ролика или клипа в секундах: «12 с», «1 мин 05 с». В отличие от
 * `formatDurationMs` (время вызова API, доли секунды важны) здесь важны целые
 * секунды и минуты. `null`/не число — «—».
 */
export function formatDurationSec(sec) {
    if (sec === null || sec === undefined || !Number.isFinite(sec))
        return '—';
    const total = Math.round(sec);
    if (total < 60)
        return `${total} с`;
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${m} мин ${String(s).padStart(2, '0')} с`;
}
/** Возраст в часах, крупно: до двух суток — «6 ч», дальше — «3 дн». */
export function formatAgeHours(hours) {
    if (hours < 48)
        return `${Math.round(hours)} ч`;
    return `${Math.round(hours / 24)} дн`;
}
//# sourceMappingURL=format-duration.js.map